module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAMAAAAolt3jAAAAaVBMVEVHcEyYmJiAgICYmJiZmZmZmZmXl5eZmZmYmJiZmZmLi4uZmZmVlZWYmJiXl5eXl5eZmZmZmZmZmZkAAACZmZmZmZmZmZmZmZmZmZmZmZmZmZmYmJiZmZmVlZWYmJiZmZmZmZmZmZmZmZl1dubPAAAAInRSTlMAzgbCsd42RqHtCxkMkFFAudQoASPzkdbZgP2ktBg+/qPgKfr3qwAAAHBJREFUCNddjkcSwyAQBBsRBEJyzkn2/P+RFuZk5rK1NRGgd0nJ9fzQRclbL8WuvFEmLCcYxaKUGcb35/EcjBa9U+Cq+zwR5CB5mC6v2wl8AlnYH47nDFaVZaU1lS1e8makeksyu22mJje97apm8x++QDEHGjk//OkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/wenhao.png
// module id = yLRj
// module chunks = 3